import { render, staticRenderFns } from "./robot-table.vue?vue&type=template&id=c322ba02"
import script from "./robot-table.vue?vue&type=script&lang=js"
export * from "./robot-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports